<mat-card>
  <form [formGroup]="editCommunicationForm" class="uf-no-form">
    <mat-toolbar color="primary">
      <h1 class="mat-title">Communicatie</h1>
      <div>
        <label>standaard</label>
        <mat-slide-toggle formControlName="standard" matTooltip="Standaard communicatie"></mat-slide-toggle>
      </div>
    </mat-toolbar>
    <mat-card-content class="uf-form">
      <mat-form-field>
        <mat-label>Type</mat-label>
        <mat-select formControlName="typeId" (selectionChange)="typeChanged()">
          @for (communicationType of communicationTypes; track communicationType.id) {
            <mat-option [value]="communicationType.id">
              {{communicationType.name}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Waarde</mat-label>
        <input matInput type="text" cdkFocusInitial formControlName="value" />
      </mat-form-field>
      <div>
        <div>
          <mat-slide-toggle formControlName="invoice" matTooltip="Gebruiken voor facturen"></mat-slide-toggle>
          <label class="p-l-8">Facturen/offertes</label>
        </div>
        <div *ngxPermissionsOnly="[permissions.REMINDER]">
          <mat-slide-toggle formControlName="reminder" matTooltip="Gebruiken voor herinneringen"></mat-slide-toggle>
          <label class="p-l-8">Herinneringen</label>
        </div>
      </div>
    </mat-card-content>
    <mat-card-actions>
      <button mat-button mat-raised-button (click)="onClose()">Annuleer</button>
      <button mat-button mat-raised-button color="primary" [disabled]="!editCommunicationForm.dirty || !editCommunicationForm.valid" (click)="onSave()">Ok</button>
    </mat-card-actions>
  </form>
</mat-card>
